import { createApp } from "vue";
import App from "./App.vue";
import router from './router/'; // Impor berkas router
import "solana-wallets-vue/styles.css";

createApp(App).use( router ).mount("#app");
